import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../../services/Api.js";
import { notification } from "antd";

export const getDashbaordData = createAsyncThunk(
    "dashbaord/getDashbaordData",
    async (id, { getState }) => {
        try {

            const authToken = document.cookie.split('; ').find(row => row.startsWith('authToken='));

            console.log("Auth Token Present:", authToken ? "YES ✓" : "NO ✗");
            if (authToken) {
                console.log("Token (first 20 chars):", authToken.substring(0, 30) + "...");
            }

            const response = await apiServices.get(`users/calls`);

            console.log("=== DASHBOARD API RESPONSE DEBUG ===");
            console.log("Total calls received:", response?.length || 0);
            console.log("Full response:", response);

            if (response && response.length > 0) {
                console.log("First call data:", response[0]);
                console.log("Advisor IDs in response:", [...new Set(response.map(call => call.advisorId || call.advisor?.id || 'N/A'))]);
                console.log("Available statuses:", [...new Set(response.map(call => call.status))]);
                console.log("Available segments:", [...new Set(response.map(call => call.segment))]);


                if (response[0].subscription || response[0].advisorId) {
                    console.log("Calls contain subscription/advisor info");
                } else {
                    console.warn("Calls missing subscription/advisor info - might be showing all calls!");
                }
            } else {
                console.log(" No calls returned (user has no subscriptions or subscribed advisors have no calls)");
            }
            console.log("=== END DEBUG ===");

            return response;
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            console.error("Error details:", error.response?.data || error.message);
            throw error;
        }
    }
);

export const getFilteredCalls = createAsyncThunk(
    "dashbaord/getFilteredCalls",
    async ({ filters, sortBy, endpoint = "calls/filter" }) => {
        try {
            const params = new URLSearchParams();


            const STATUS_MAP = {
                "LIVE": "LIVE",
                "YET_TO_TRIGGER": "YET_TO_TRIGGER",
                "CLOSED_TARGETHIT": "CLOSED_TARGETHIT",
                "CLOSED_STOPLOSSHIT": "CLOSED_STOPLOSSHIT"
            };


            const SEGMENT_MAP = {
                "Equity": "EQUITY",
                "Index Options": "INDEX_OPTIONS",
                "Stock Options": "STOCK_OPTIONS",
                "Stock Futures": "FUTURES"
            };

            if (filters && filters.status && filters.status.length > 0) {
                filters.status.forEach(status => {
                    const backendStatus = STATUS_MAP[status] || status;
                    params.append('statuses', backendStatus);
                });
            }

            if (filters && filters.segment && filters.segment.length > 0) {
                filters.segment.forEach(segment => {
                    const backendSegment = SEGMENT_MAP[segment] || segment;
                    params.append('segments', backendSegment);
                });
            }

            if (sortBy) {

                const sortMapping = {
                    "max_profit": "MAX_PROFIT",
                    "risk_reward_high_to_low": "RISK_REWARD",
                    "confidence_high_to_low": "CONFIDENCE_HIGH_TO_LOW",
                    "duration_low_to_high": "DURATION_LOW_TO_HIGH",
                    "newest_first": "NEWEST_FIRST",
                };

                const mappedSort = sortMapping[sortBy] || sortBy;
                console.log("Original sortBy:", sortBy);
                console.log("Mapped sortBy:", mappedSort);
                params.append('sortBy', mappedSort);
            }

            let response;
            try {
                response = await apiServices.get(`${endpoint}?${params.toString()}`);
                console.log("Filter API URL:", `${endpoint}?${params.toString()}`);
                console.log("Filters sent:", filters);
                console.log("Sort sent:", sortBy);
            } catch (err) {
                console.warn("Filtered fetch failed, attempting fallback to unfiltered list", err);
                try {
                    response = await apiServices.get(`${endpoint}`);
                    console.log("Fallback API response:", response);
                } catch (fallbackErr) {
                    console.error("Fallback fetch also failed", fallbackErr);
                    throw fallbackErr;
                }
            }


            if (response && response.length > 0 && sortBy) {

                const sortedResponse = [...response].sort((a, b) => {
                    switch (sortBy) {
                        case 'max_profit':
                            return (b.maximumProfitPercentage || 0) - (a.maximumProfitPercentage || 0);
                        case 'risk_reward_high_to_low':

                            const riskA = Math.abs(a.minimumLossPercentage || 0);
                            const rewardA = a.maximumProfitPercentage || 0;
                            const riskRewardA = riskA > 0 ? rewardA / riskA : 0;

                            const riskB = Math.abs(b.minimumLossPercentage || 0);
                            const rewardB = b.maximumProfitPercentage || 0;
                            const riskRewardB = riskB > 0 ? rewardB / riskB : 0;

                            return riskRewardB - riskRewardA;
                        case 'confidence_high_to_low':
                            return (b.confidence || 0) - (a.confidence || 0);
                        case 'confidence_low_to_high':
                            return (a.confidence || 0) - (b.confidence || 0);
                        case 'duration_low_to_high':
                            return (a.duration || 0) - (b.duration || 0);
                        case 'duration_high_to_low':
                            return (b.duration || 0) - (a.duration || 0);
                        case 'newest_first':
                            return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
                        case 'oldest_first':
                            return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
                        case 'target_price_high_to_low':
                            return (b.targetPrice || 0) - (a.targetPrice || 0);
                        case 'target_price_low_to_high':
                            return (a.targetPrice || 0) - (b.targetPrice || 0);
                        default:
                            return 0;
                    }
                });

                console.log("Applied client-side sorting for:", sortBy);
                return sortedResponse;
            }

            // Test: Try filter API without any parameters to see if it returns data
            if (!response || response.length === 0) {
                console.log("No results with filters, testing filter API without parameters...");
                try {
                    const testResponse = await apiServices.get(`advisors/calls`);
                    console.log("Filter API without params response:", testResponse);


                    if (testResponse && testResponse.length > 0) {
                        console.log("=== CALL OBJECT STRUCTURE ===");
                        console.log("First call object:", testResponse[0]);
                        console.log("All field names:", Object.keys(testResponse[0]));
                        console.log("Status field value:", testResponse[0].status);
                        console.log("Segment field value:", testResponse[0].segment);
                        console.log("Status type:", typeof testResponse[0].status);
                        console.log("Segment type:", typeof testResponse[0].segment);

                        // Check a few more calls to see the patterns
                        console.log("Sample statuses from first 3 calls:");
                        testResponse.slice(0, 3).forEach((call, i) => {
                            console.log(`Call ${i + 1} status: "${call.status}" | segment: "${call.segment}"`);
                        });
                        console.log("=== END STRUCTURE DEBUG ===");
                    }
                } catch (testError) {
                    console.log("Filter API without params failed:", testError);
                }
            }

            return response;
        } catch (error) {
            console.error("Error fetching filtered calls:", error);
            throw error;
        }
    }
);


//get Summary Card data

export const getSummaryData = createAsyncThunk(
    "dashbaord/getSummaryData",
    async (id) => {
        try {
            const response = await apiServices.get(`/calls/${id}`);
            console.log(response);
            return response;
        } catch (error) {
            console.error("Error fetching summary data:", error);
            throw error;
        }
    }
);




const initialState = {
    data: [],
    summaryData: [],
    filteredData: null,
    loading: false,
    error: ""
};

const DashboardSlice = createSlice({
    name: "dashboard",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getDashbaordData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getDashbaordData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = [action.payload];
                console.log("Dashboard API response structure:", action.payload);
                console.log("First item in response:", action.payload[0]);
                if (action.payload[0] && action.payload[0].length > 0) {
                    console.log("First call data:", action.payload[0][0]);
                    console.log("First call available fields:", Object.keys(action.payload[0][0] || {}));
                }
            })
            .addCase(getDashbaordData.rejected, (state, action) => {
                state.loading = false;
                state.error = "Error while fetching dashboard details";
                notification.error({
                    message: state?.error
                });
            })
            .addCase(getSummaryData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getSummaryData.fulfilled, (state, action) => {
                state.loading = false;
                state.summaryData = [action.payload];
                console.log("action payload summary", state.summaryData);
            })
            .addCase(getSummaryData.rejected, (state, action) => {
                state.loading = false;
                state.error = "Error while fetching summary details";
                notification.error({
                    message: state?.error
                });
            })
            .addCase(getFilteredCalls.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getFilteredCalls.fulfilled, (state, action) => {
                state.loading = false;
                state.filteredData = action.payload;
                console.log("Filtered API response:", action.payload);
            })
            .addCase(getFilteredCalls.rejected, (state, action) => {
                state.loading = false;

            })
            .addCase(exitTrade.fulfilled, (state, action) => {
                if (state.filteredData) {
                    state.filteredData = state.filteredData.filter(item => item.id !== action.meta.arg);
                }
                notification.success({ message: "Trade exited successfully" });
            })
            .addCase(ignoreTrade.fulfilled, (state, action) => {
                if (state.filteredData) {
                    state.filteredData = state.filteredData.filter(item => item.id !== action.meta.arg);
                }
                notification.success({ message: "Trade ignored successfully" });
            })
            .addCase(exitTrade.rejected, (state, action) => {
                notification.error({ message: action.payload || "Failed to exit trade" });
            })
            .addCase(ignoreTrade.rejected, (state, action) => {
                notification.error({ message: action.payload || "Failed to ignore trade" });
            });
    },
});

export const exitTrade = createAsyncThunk(
    "dashboard/exitTrade",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await apiServices.post("advisors/exit", { id });
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ignoreTrade = createAsyncThunk(
    "dashboard/ignoreTrade",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await apiServices.post("advisors/ignore", { id });
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const DashboardReducer = DashboardSlice.reducer;

export default DashboardReducer;
